export function compactEditorDialog(anchor: { left: number; top: number; width: number; height: number },
  viewport: { left: number; top: number; right: number; bottom: number }) {
  const width = Math.min(680, Math.max(1, viewport.right - viewport.left - 32));
  const height = Math.min(580, Math.max(1, viewport.bottom - viewport.top - 32));
  return {
    width, height,
    left: Math.max(viewport.left + 16, Math.min(anchor.left + anchor.width / 2 - width / 2, viewport.right - width - 16)),
    top: Math.max(viewport.top + 16, Math.min(anchor.top + Math.min(anchor.height, 300) / 2 - height / 2, viewport.bottom - height - 16))
  };
}
